import { Component, ViewEncapsulation } from "@angular/core";
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FooterComponent } from '../shared/footer/footer.component';
import { TenantPublicContentService } from '../tenant/tenant-public-content.service';
import { TenantHeroImageComponent } from '../shared/tenant-hero-image/tenant-hero-image.component';
import { OFFICIAL_FIBA_RULES_URL } from '../tenant/tenant-policy-content';

@Component({
  selector: 'app-rules-regulations',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FooterComponent,
    TenantHeroImageComponent
  ],
  templateUrl: './rules-regulations.component.html',
  styleUrls: ['./rules-regulations.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class RulesRegulationsComponent {
  content$ = this.tenantContent.content$;
  readonly officialFibaRulesUrl = OFFICIAL_FIBA_RULES_URL;

  constructor(private tenantContent: TenantPublicContentService) {}
}

